import createReducer from '../createReducer';
import {
  FETCH_MENU_LOCATIONS,
  FETCH_MENU_LOCATIONS_SUCCESS,
  FETCH_MENU_LOCATIONS_FAILURE,
} from '../../actions/cms/menuLocations';

const initialState = {
  loading: false,
  menuLocations: {},
};

const handlers = {};

handlers[FETCH_MENU_LOCATIONS] = state => ({
  ...state,
  loading: true,
});

handlers[FETCH_MENU_LOCATIONS_SUCCESS] = (state, { menuLocations }) => ({
  ...state,
  loading: false,
  menuLocations,
});

handlers[FETCH_MENU_LOCATIONS_FAILURE] = (state, { error }) => ({
  ...state,
  loading: false,
  error,
});

export default createReducer(handlers, initialState);



// WEBPACK FOOTER //
// ./src/reducers/cms/menuLocations.js